export function useArrangeSubmit(applyArranges) {
  const onFinish = async () => {
    // TODO: make close
    await applyArranges();
  };

  return { onFinish };
}
